import React from "react";
import ApplicationHeader from "../../../application/ApplicationHeader";
import { Container } from "@mui/material";
import ApplicationPanel from "../../../application/ApplicationPanel";
import SftpAccountBrowse from "./SftpAccountBrowse";
import { createAppQueryClient } from "../../../application/queryClients";
import { AppQueryClientProvider } from "../../../application/AppQueryClientProvider";

// Create a client
const queryClient = createAppQueryClient({
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: Infinity,
});

const ManageSftpAccounts = () => {
  return (
    <Container id="manage-sftp-accounts">
      <ApplicationHeader />

      <ApplicationPanel>
        <AppQueryClientProvider client={queryClient}>
          <SftpAccountBrowse />
        </AppQueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageSftpAccounts;
